import { useEffect, useRef, useState } from "react";
import InformationErrorModal from "../../../Components/Components/Modals/InformationErrorModal";
import { DateBox } from 'devextreme-react'
import { useOrder } from "../../../Providers/OrderProvider";
import axios from "axios";
import { useParams } from "../../../Providers/ParamsProvider";

const OrdersFilterSection = ({ ordersFilterCriteria, setOrdersFilterCriteria }) => {
    const dateFromRef = useRef(null)
    const dateToRef = useRef(null)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const { handleGetOrderFiltersData } = useOrder()

    // Pobranie unikalnych wartości do wyboru w filtrach
    const [sellers, setSellers] = useState([])
    const [addresses, setAddresses] = useState([])
    const { isMobile } = useParams()

    useEffect(() => {
        const source = axios.CancelToken.source()

        clearFilters()
        handleGetOrdersFiltersData(source.token)

        return () => {
            source.cancel()
        }
    }, [ordersFilterCriteria.isArchive])

    const handleGetOrdersFiltersData = async (cancelToken) => {
        const res = await handleGetOrderFiltersData(ordersFilterCriteria, cancelToken)
        if (res) {
            setAddresses(res.addresses)
            setSellers(res.sellers)
        }
    }

    const clearFilters = () => {
        setOrdersFilterCriteria(prev => ({
            ...prev,
            dateFrom: null,
            dateTo: null,
            selectedSeller: '',
            selectedAddress: '',
            orderBy: 1,
            selectedStatus: '',
        }))
        if (dateFromRef.current) {
            dateFromRef.current.instance.reset()
        }
        if (dateToRef.current) {
            dateToRef.current.instance.reset()
        }
    }

    const changeFilterValue = (props, value) => {
        setOrdersFilterCriteria(prev => ({
            ...prev,
            [props]: value
        }))
    }

    const DateToOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10)
            // if (dateFrom.length === 0) {
            //     setDateTo(selectedDate)
            if (selectedDate < ordersFilterCriteria.dateFrom) {
                setErrorMessage('Data DO nie może być wcześniejsza niż data OD!')
                setShowError(true)
                if (dateToRef.current) {
                    dateToRef.current.instance.reset()
                }
                changeFilterValue('dateTo', null)
            } else {
                changeFilterValue('dateTo', selectedDate)
            }
        }
    }

    const DateFromOnValueChanged = (e) => {
        if (e.value) {
            const selectedDate = e.value.toLocaleString('en-CA').substring(0, 10);

            // if (dateTo.length === 0) {
            //     setDateFrom(selectedDate)
            if (selectedDate > ordersFilterCriteria.dateTo) {
                setErrorMessage('Data OD nie może być poźniejsza niż data DO!')
                setShowError(true)
                if (dateFromRef.current) {
                    dateFromRef.current.instance.reset()
                }
                changeFilterValue('dateFrom', null)
            } else {
                changeFilterValue('dateFrom', selectedDate)
            }
        }
    }

    return (<>
        <InformationErrorModal show={showError} setShow={setShowError} title={'Błędna data'} message={errorMessage} isError={false} />
        {isMobile ?
            <div className="row">
                <div className='col-6 date-filter'>
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                </div>
                <div className="col-6 date-filter">
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                </div>
                <div className="filters col-12 d-grid">
                    <div>
                        <label style={{ fontSize: '14px', minWidth: '350px' }} htmlFor="seller">Sprzedający</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="seller"
                            value={ordersFilterCriteria.selectedSeller}
                            onChange={(e) => changeFilterValue('selectedSeller', e.target.value)}
                        >
                            <option value="">Wszyscy sprzedający</option>
                            {sellers.map((seller, index) => (
                                <option key={index} value={seller.id}>{seller.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px', minWidth: '350px' }} htmlFor="address">Adres dostawy</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="address"
                            value={ordersFilterCriteria.selectedAddress}
                            onChange={(e) => changeFilterValue('selectedAddress', e.target.value)}
                        >
                            <option value="">Wszystkie adresy</option>
                            {addresses.map((address, index) => (
                                <option key={index} value={address}>{address}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="order"
                            value={ordersFilterCriteria.orderBy}
                            onChange={(e) => changeFilterValue('orderBy', e.target.value)}
                        >
                            <option value={1}>Najnowsze</option>
                            <option value={2}>Najstarsze</option>
                            <option value={3}>Nr zam. malejąco</option>
                            <option value={4}>Nr zam. rosnąco</option>
                            <option value={5}>Nr zam. klienta malejąco</option>
                            <option value={6}>Nr zam. klienta rosnąco</option>
                            <option value={7}>Adres malejąco</option>
                            <option value={8}>Adres rosnąco</option>
                        </select>
                    </div>
                    <button
                        style={{ fontSize: '15px', height: '40px' }}
                        onClick={() => { clearFilters() }}
                        className='btn-app-primary'>
                        X
                    </button>
                </div>
            </div> :
            <div className="row">
                <div className='col-12 col-lg-2 col-md-4 date-filter'>
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Od</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateFromOnValueChanged} ref={dateFromRef} />
                </div>
                <div className="col-12 col-lg-2 col-md-4 date-filter">
                    <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Do</label>
                    <DateBox acceptCustomValue={false} adaptivityEnabled={true} onValueChanged={DateToOnValueChanged} ref={dateToRef} />
                </div>
                <div className="filters col-7">
                    <div>
                        <label style={{ fontSize: '14px', minWidth: '350px' }} htmlFor="seller">Sprzedający</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="seller"
                            value={ordersFilterCriteria.selectedSeller}
                            onChange={(e) => changeFilterValue('selectedSeller', e.target.value)}
                        >
                            <option value="">Wszyscy sprzedający</option>
                            {sellers.map((seller, index) => (
                                <option key={index} value={seller.id}>{seller.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px', minWidth: '350px' }} htmlFor="address">Adres dostawy</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="address"
                            value={ordersFilterCriteria.selectedAddress}
                            onChange={(e) => changeFilterValue('selectedAddress', e.target.value)}
                        >
                            <option value="">Wszystkie adresy</option>
                            {addresses.map((address, index) => (
                                <option key={index} value={address}>{address}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label style={{ fontSize: '14px' }} htmlFor="seller">Sortuj według</label>
                        <select
                            style={{ fontSize: '14px' }}
                            id="order"
                            value={ordersFilterCriteria.orderBy}
                            onChange={(e) => changeFilterValue('orderBy', e.target.value)}
                        >
                            <option value={1}>Najnowsze</option>
                            <option value={2}>Najstarsze</option>
                            <option value={3}>Nr zam. malejąco</option>
                            <option value={4}>Nr zam. rosnąco</option>
                            <option value={5}>Nr zam. klienta malejąco</option>
                            <option value={6}>Nr zam. klienta rosnąco</option>
                            <option value={7}>Adres malejąco</option>
                            <option value={8}>Adres rosnąco</option>
                        </select>
                    </div>
                    <button
                        style={{ fontSize: '15px', width: '40px', height: '40px' }}
                        onClick={() => { clearFilters() }}
                        className='btn-app-primary mt-4'>
                        X
                    </button>
                </div>
            </div>}
    </>)
}

export default OrdersFilterSection